<template lang="html">
  <div>
    <h4 class="mt-2">My Preferences</h4>
    <b-card>
      <b-container class="p-0 bv-example-row">
        <h5 class="mt-2 mb-2"><i class="fa fa-bullhorn"></i> Communications</h5>
        <b-row>
          <b-col lg="1" md="1" class="mt-2">
            <b>Newsletter</b>
          </b-col>
          <b-col lg="11" md="11" class="mt-2">
            <b-form-checkbox
              v-model="receivesNewsletter"
              :value=true
              :unchecked-value=false
              switch
              size="lg">
              <span>{{ receivesNewsletter ? 'You are signed up ' : 'You are Not signed up ' }} for CitSci.org e-newsletters (sent monthly via
                <b-link
                  href="https://mailchimp.com/" target="_blank" rel="noopener noreferrer">MailChimp <i
                  class="fas fa-external-link-alt fa-xs"></i></b-link>)</span>
            </b-form-checkbox>
          </b-col>
        </b-row>

        <h5 class="mt-4 mb-3"><i class="fa fa-lock"></i> Privacy</h5>
        <b-form-group
          label=""
          v-slot="{ ariaDescribedby }"
        >
          <div class="mb-3">
            <b class="mr-3">Display Name:</b>
            <span><font-awesome-icon icon="spinner" pulse v-show="isLoading"/> {{ displayName }}</span>
          </div>
          <b-form-checkbox-group
            v-model="privacySetting"
            :options="allPrivacySettings"
            :aria-describedby="ariaDescribedby"
            switches
            size="lg"
            stacked
          ></b-form-checkbox-group>
        </b-form-group>
      </b-container>
    </b-card>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  components: {},
  data() {
    return {
      receivesNewsletterLocal: null,
      privacySettingLocal: null,
      allPrivacySettings: [
        {text: 'Show Full Name', value: 1, disabled: false,},
        {text: 'Show First Name Last Initial', value: 2, disabled: false,},
        {text: 'Show Username', value: 3, disabled: false,},
        {text: 'Show me as Anonymous (except to project managers)', value: 4, disabled: false,},
      ],
    }
  },

  created() {
    // Initial values are set
    if (!this.receivesNewsletterLocal) {
      this.receivesNewsletterLocal = this.receivesNewsletterVuex
      this.receivesNewsletter = this.receivesNewsletterVuex
    }
    if (!this.privacySettingLocal) {
      this.privacySettingLocal = this.privacySettingVuex
      this.privacySetting = this.privacySettingVuex
    }
  },
  watch: {
    receivesNewsletterVuex(newVal) {
      if (newVal) {
        this.receivesNewsletterLocal = newVal
        this.receivesNewsletter = newVal
      }
    },
    privacySettingVuex(newVal) {
      if (newVal) {
        this.privacySettingLocal = newVal
        this.privacySetting = newVal
      }
    },
  },
  destroyed() {},
  computed: {
    ...mapGetters({
      isLoading: "user/profile/isLoadingUpdate",
      receivesNewsletterVuex: "user/profile/receivesNewsletter",
      privacySettingVuex: "user/profile/privacySetting",
      displayName: "user/profile/displayName",
    }),
    receivesNewsletter: {
      get() {
        return this.receivesNewsletterLocal
      },
      set(value) {
        if (this.receivesNewsletterLocal !== value) {
          this.updateUserProfile({receivesNewsletter: value})
        }
      },
    },
    privacySetting: {
      get() {
        return this.privacySettingLocal
      },
      set(value) {
        // This is done to keep the user from unchecking the currently checked value
        // - makes checkboxes work like radio buttons!
        this.allPrivacySettings.forEach(val => {
          val.disabled = val.value === value
        })
        if (this.privacySettingLocal !== value) {
          this.updateUserProfile({privacySetting: value})
        }
      }
    },
  },
  methods: {
    ...mapActions({
      updateUserProfile: "user/profile/updateUserProfile",
    }),

  },
}
</script>
<style lang="scss" scoped>
</style>
